import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledIFrame = styled.div`
  padding-bottom: 60px;
  text-align: center;
`;

export const DashboardIframe = ({ insightKey, insightToken, dashboardId }) => {
  const prevInsightToken = usePrevious(insightToken);
  const prevDashboardId = usePrevious(dashboardId);
  useEffect(
    () => {
      // If a new dashboard has been selected, re-render the iFrame with the
      // new token, key, and dashboard_id. If nothing has changed, do not re-render
      if (!dashboardId) return;
      if (prevInsightToken === insightToken && prevDashboardId === dashboardId) return;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `(function(a,e,f,g,b,c,d) {a[b]||(c=e.createElement(f),c.async=1,c.src=g,d=e.getElementsByTagName(f)[0],d.parentNode.insertBefore(c,d));a[b]=a[b]||{};a[b].addDashboard=a[b].addDashboard||function(c){(a[b].list=a[b].list||[]).push(c)}})(window,document,'script','https://cdn-a.cumul.io/js/cumulio.min.js','Cumulio'); Cumulio.addDashboard({ dashboardId: '${dashboardId}', container: '#my-dashboard', key: '${insightKey}', token: '${insightToken}'});`;
      document.body.appendChild(script);
    },
    [insightKey, insightToken, dashboardId, prevInsightToken, prevDashboardId]
  );

  return <StyledIFrame id="my-dashboard" />;
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
